import { useCallback, useContext } from 'react';

import { context as DependencyContext } from '../../context/dependency';

const useUpdateViewedAt = () => {
  const dependency = useContext(DependencyContext);

  const updateViewedAt = useCallback(
    (id: string) => {
      try {
        dependency.offer.assignmentWebApi.updateViewedAt(id);
      } catch (err) {
        console.log(err);
      }
    },
    [dependency.offer.assignmentWebApi],
  );

  return { updateViewedAt };
};

export default useUpdateViewedAt;
